import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import {
  IconModule,
  TooltipModule,
  AvatarModule,
  TagModule
} from '@liberty-financial/ng-components';

import { PipesModule } from '@shared/pipes/pipes.module';

import { AppbarComponent } from './appbar.component';

@NgModule({
  declarations: [AppbarComponent],
  imports: [
    CommonModule,
    IconModule,
    TooltipModule,
    AvatarModule,
    TagModule,
    PipesModule
  ],
  exports: [AppbarComponent]
})
export class AppbarModule {}
